// extracted by mini-css-extract-plugin
export default {"root":"ExamUploadModal_root__CheEL","examName":"ExamUploadModal_examName__YE377","footer":"ExamUploadModal_footer__YddxQ"};